module.exports = __webpack_public_path__ + "img/31_17.d2acfc49.png";